import React, { useEffect, useRef, useState } from "react";
import photographer from "./images/photographer.svg";
import popup from "./images/popup-bg.png";
import "./styles/style.css";
import Telemetry from "../../utils/rudderstackAnalytics";
declare global {
  interface Window {
    hbspt: {
      forms: {
        create: (options: {
          region: string;
          portalId: string;
          formId: string;
          target: string;
        }) => void;
      };
    };
  }
}

const HubSpotForm = ({ activeForm }: { activeForm: string }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.charset = "utf-8";
    script.type = "text/javascript";

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "42524444",
          formId:
            activeForm == "ph"
              ? "638fb581-cec3-4fe6-814c-42c276602cf8"
              : "4773849e-0a16-4331-b136-853a9c94b27e",
          target: "#hubspotForm",
          onFormSubmitted: () => {
            Telemetry.track(
              "internal-referrals:org-gallery-sell-your-photos-referral-submitted"
            );
          }
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [activeForm]);

  return <div id="hubspotForm"></div>;
};

const SellYourPhotos = ({
  handleCloseClick
}: {
  handleCloseClick: Function;
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [activeForm, setActiveForm] = useState("ph");

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        handleCloseClick();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleCloseClick]);

  return (
    <div>
      <div
        id="modal-dialog"
        className="modal fade in geo-modal geo-modal--small geo-modal--warning geo-modal--show 
        geo-modal--scroll"
        role="dialog"
      >
        <div
          className="modal-dialog filter-dialog-content geo-privacy-body geo-privacy-modal invite-modal"
          ref={popupRef}
        >
          <div
            className="modal-content"
            style={{
              backgroundImage: `url(${popup})`,
              backgroundPositionY: "bottom",
              backgroundRepeat: "no-repeat",
              backgroundSize: "100%",
              minHeight: `448px`
            }}
          >
            <div className="modal-header">
              &nbsp;
              <button className="close" onClick={() => handleCloseClick()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="geo-modal__header geo-modal--warning-bg">
              <img
                className="geo-modal__warn-icon"
                src={photographer}
                alt="photographer-icon"
                style={{ width: 180 }}
              />
              <h4>I am a</h4>
              <div className="sell-your-photos-btn-cotainer">
                <button
                  className={`geo-btn ${
                    activeForm == "ph" ? "active-btn" : ""
                  }`}
                  onClick={() => {
                    Telemetry.track(
                      "internal-referrals:org-gallery-ph-referral-btn-clicked"
                    );
                    setActiveForm("ph");
                  }}
                >
                  Photographer
                </button>
                <button
                  className={`geo-btn ${
                    activeForm == "club" ? "active-btn" : ""
                  }`}
                  onClick={() => {
                    Telemetry.track(
                      "internal-referrals:org-gallery-club-referral-btn-clicked"
                    );
                    setActiveForm("club");
                  }}
                >
                  Club
                </button>
              </div>
              <span className="sell-your-photos-sub-header">
                Learn more about how GeoSnapShot takes your photo sales to the
                next level.
              </span>
            </div>
            <div className="geo-modal__body">
              <br />
              <HubSpotForm activeForm={activeForm} />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default SellYourPhotos;
